import React from 'react'
import fishes from '../images/grillMaster.svg'
import beer from '../images/beerParty.svg'
import ogImage from '../images/ogImage.png';

import { motion, AnimatePresence } from "framer-motion"
const Hero = ({isEng, highlights, isFood}) => {
 
  let highlight
  if(highlights){
      highlight  = highlights[0]
      
  }
   
  return (
    <div className='relative m-[2px] rounded-md  bg-greenOne text-center italic p-2 leading-[1rem]  text-greenTwo'>
      {isFood &&
        (
          <div>
            <img className='hidden' alt="showcase" src={ogImage} /> 
            <motion.img
                  inital={{scale:0}}
                  animate={{scale:1.2, rotate:35}}            
            className='absolute -top-2 w-[70px] -right-0  ' src={fishes} />
            <h1 className='m-1 text-2xl font-bold'>{!isEng ? highlight?.highlight1 : highlight?.highlight1_eng}</h1>
            <p className='text-md'>{!isEng ? highlight?.highlight2 : highlight?.highlight2_eng}.</p>
          </div>
        ) }
        {!isFood && 
        (
          <div>
            <motion.img inital={{scale:0}}
                  animate={{scale:1.2, rotate:25}}     className='absolute top-1 w-[80px] right-1 -rotate-[15deg]' src={beer} />
            <h1 className='m-2 text-2xl font-bold'>{!isEng ? highlight?.highlight1_drinks : highlight?.highlight1_drinks_eng}</h1>
            <p className='text-md'>{!isEng ?  highlight?.highlight2_drinks : highlight?.highlight2_drinks_eng}</p>
          </div>
        )}

    </div>
  )
}

export default Hero